import { useState } from 'react'

import { Accordion } from '@interco/inter-ui/components/Accordion'

import * as S from './SectionAccordion.styles'

export const SectionAccordion = ({
  content,
  title,
}: {
  content: React.ReactNode
  title: string
}) => {
  const [expanded, setExpanded] = useState(true)
  return (
    <S.AccordionSection>
      <Accordion title={title} expanded={expanded} onClick={() => setExpanded(!expanded)}>
        {content}
      </Accordion>
    </S.AccordionSection>
  )
}
